export default __webpack_public_path__ + "static/media/14.4c1fa757.png";